import { useLayoutEffect, useCallback } from 'react';

import { KEYBOARD_KEY_CODES, KeyboardKeys } from '../../constants/keyboard';

import { useOnKeyDown } from './use-on-key-down';

interface Params {
    isMovieActionsBlocked?: boolean;
    onClose?: () => void;
}

export const useKeyboard = ({ isMovieActionsBlocked, onClose }: Params) => {
    const onKeyDownBase = useOnKeyDown({ onClose });

    const onKeyDown = useCallback(
        (event: KeyboardEvent) => {
            const { Escape } = KeyboardKeys;

            if (event.code === Escape || !isMovieActionsBlocked) {
                if (KEYBOARD_KEY_CODES.some((code) => code === event.code)) {
                    event.preventDefault();
                }
                onKeyDownBase(event);
            }
        },
        [isMovieActionsBlocked, onKeyDownBase]
    );

    useLayoutEffect(() => {
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, [onKeyDown]);
};
